import React, { useState } from 'react';

import Form from '../../../../components/Form';
import FeedbackCard from '../../../../components/FeedbackCard';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import { MaterialIcon } from '../../../../components/MaterialIcon';

const AddEdit = ({ formModel, isNew, data, closeDialog, onApply, saveDisabled }) => {
    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const [compose, updateCompose] = useState(false);
    const [edited, setEdited] = useState(false);
    const [loading, setLoading] = useState('');
    const [errors, setErrors] = useState({});
    const [fatalError, setFatalError] = useState(null);

    const applySuccess = () => {
        setLoading('success');
        setFatalError(null);
        setTimeout(() => {
            setLoading('');
            CloseDialog();
        }, 500);
    };

    const onApplyFormState = (formState) => {
        if (saveDisabled) {
            console.warn("Authoring Interface is currently read-only.");
            return;
        }
        let update = {
            ...data,
            ...formState
        };
        updateCompose(false);
        let { valid, failureMsg } = validate(update);
        if (valid) {
            setLoading('loading');
            onApply(update)
                .then((resp) => {
                    applySuccess();
                })
                .catch((e) => {
                    setFatalError(e);
                    setLoading('');
                });
        }
    };

    // Temporary validation solution
    const validate = (formState) => {
        let errors = {};
        for (let field of formModel) {
            let { valid, failed } = field.validation(formState[field.accessor]);
            if (!valid) {
                errors[field.accessor] = 'Invalid Input: ' + failed.join(', ');
            }
            // Add additional validation here;
        }
        // Add relational validation here

        setErrors(errors);
        let valid = Object.keys(errors).length === 0;
        return { valid, failureMsg: '' };
    };

    return (
        <div style={{ height: `30rem` }}>
            <Dialog close={CloseDialog} visible id="node-manager-addEdit">
                <DialogHeader close={CloseDialog}>
                    {isNew
                        ? 'Add Input Node'
                        : `Edit ${data.attributeName} - ${data.nodePath}`}
                </DialogHeader>
                <DialogBody>
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message:
                                    typeof fatalError === 'string'
                                        ? fatalError
                                        : `Please wait a few moments before trying your request
again.`
                            }}
                            details={fatalError}
                        />
                    )}
                    {isNew ? 'Enter' : 'Adjust'} required information below.
                    <p style={{ margin: `1.33rem 0 0 0` }}></p>
                    <Form
                        formModel={formModel}
                        isNew={isNew}
                        data={data}
                        errors={errors}
                        compose={compose}
                        onApplyFormState={onApplyFormState}
                        setEdited={setEdited}
                        fatalError={fatalError}
                    />
                </DialogBody>
                <DialogFooter>
                    {loading === 'loading' && (
                        <div style={{ marginRight: '0.5rem' }}>Loading...</div>
                    )}
                    {loading === 'success' && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon
                                icon={'done_outline'}
                                color={'#04846D'}
                            />
                        </div>
                    )}
                    {isNew ? (
                        <Button
                            text
                            appearance="primary"
                            onClick={() => updateCompose(true)}
                            disabled={!edited || saveDisabled}
                            loading={loading !== ''}
                        >
                            Add
                        </Button>
                    ) : (
                        <>
                            <Button
                                text
                                appearance="primary"
                                disabled={!edited || saveDisabled}
                                onClick={() => updateCompose(true)}
                                loading={loading !== ''}
                            >
                                Save Input Node
                            </Button>
                        </>
                    )}
                    <Button text appearance="secondary" onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

export default AddEdit;
